<template>
  <b-modal
    ref="shareCaseModal"
    :title="$t('diagnosis.btns.share')"
    centered
    modal-class="share-case-modal"
    :hide-footer="viewMode && caseShared"
  >
    <template #modal-title>
      <div v-if="!caseShared">
        {{ $t('diagnosis.btns.share') }}
      </div>
      <div v-if="caseShared && !viewMode">
        {{ $t('diagnosis.modals.updateShareTitle') }}
      </div>
      <div v-if="caseShared && viewMode">
        {{ $t('diagnosis.modals.caseShared') }}
      </div>
    </template>
    <b-container>
      <b-row class="mt-1">
        <b-col>
          <b-row>
            <b-col v-if="!viewMode">
              <h5>{{ $t('diagnosis.modals.shareTitle') }}</h5>
            </b-col>
            <b-col
              v-if="viewMode"
              class="view-mode-header"
            >
              <h5>
                <i
                  class="fal fa-chart-network mr-2"
                  aria-hidden="true"
                /> H3C20-000026
              </h5>
              <div>
                <span class="shared-by">{{ $t('diagnosis.modals.sharedBy') }} SÁNCHEZ VARELA MARÍA JESÚS</span>
              </div>
              <div>
                <!-- TODO: Fecha en la que se compartió el estudio, no incluye actualizaciones -->
                <span class="date"><i
                  class="fal fa-calendar-alt mr-2"
                  aria-hidden="true"
                /> 00/00/0000 00:00</span>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!viewMode">
            <b-col cols="5">
              <div>
                <div class="form-label">
                  <label>
                    {{ $t('global.center') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="selected"
                  v-validate="'required'"
                  class="nowrap"
                  track-by="value"
                  :options="options"
                  label="text"
                />
              </div>
            </b-col>
            <b-col class="pr-1">
              <div>
                <div class="form-label">
                  <label>
                    {{ $t('diagnosis.modals.users') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="selected"
                  v-validate="'required'"
                  class="nowrap"
                  track-by="value"
                  :options="options"
                  label="text"
                />
              </div>
            </b-col>
            <b-col
              cols="auto"
              class="d-flex align-items-center justify-content-center"
            >
              <button
                v-tooltip="$t('diagnosis.modals.addAllUsers')"
                type="button"
                class="pt-4 btn btn__icon btn__icon--primary px-1 btn-secondary my-0"
              >
                <i
                  class="far fa-share-all"
                  aria-hidden="true"
                />
              </button>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col>
              <div class="list">
                <!-- TODO: Tener en cuenta el siguiente "empty-state" cuando no hay usuarios seleccionados, he usado un data mockeado -->
                <div
                  v-if="noUserSelected"
                  class="empty-state d-flex flex-column align-items-center justify-content-center h-100"
                >
                  <i
                    class="fal fa-user-friends"
                    aria-hidden="true"
                  />
                  <h5>{{ $t('diagnosis.modals.emptyTitle') }}</h5>
                  <span>{{ $t('diagnosis.modals.emptySubtitle') }}</span>
                </div>
                <div
                  v-if="!noUserSelected"
                  class="header-row"
                >
                  <b-row class="form-label">
                    <b-col>
                      <!-- TODO: El userSelected que sea dinámico en función de si es uno o varios -->
                      <span
                        v-if="!viewMode"
                        class="primary-title"
                      >{{ users.length }} {{ $tc('diagnosis.modals.usersSelected', users.length) }}</span>
                      <span
                        v-if="viewMode"
                        class="primary-title"
                      >{{ $t('diagnosis.modals.sharedTo') }} {{ users.length }} <span
                        class="primary-title"
                        style="text-transform: lowercase"
                      >{{ $t('diagnosis.modals.users') }}</span></span>
                    </b-col>
                    <b-col v-if="!viewMode">
                      <button
                        v-tooltip="$t('global.clean')"
                        type="button"
                        class="btn btn__icon btn__icon--primary px-1 btn-secondary my-0"
                      >
                        <i
                          class="far fa-eraser"
                          aria-hidden="true"
                        />
                      </button>
                    </b-col>
                  </b-row>
                </div>
                <div
                  v-if="!noUserSelected"
                  class="mt-1"
                >
                  <div
                    v-for="(user, index) in users"
                    :key="index"
                    class="element-row"
                  >
                    <b-row class="form-label">
                      <b-col
                        cols="5"
                        class="d-flex align-items-center"
                      >
                        <span class="ml-2"><i
                          class="far fa-hospital mr-2"
                          aria-hidden="true"
                        />{{ user.center }}</span>
                      </b-col>
                      <b-col class="d-flex align-items-center">
                        <span><i
                          class="far fa-user mr-2"
                          aria-hidden="true"
                        />{{ user.user }}</span>
                      </b-col>
                      <b-col
                        v-if="!viewMode"
                        cols="auto"
                      >
                        <button
                          v-tooltip="$t('shipments.modal.deleteElement')"
                          type="button"
                          class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0"
                        >
                          <i
                            class="far fa-times mr-2"
                            aria-hidden="true"
                          />
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="3"
          class="bordered-column px-4"
          :class="{'view-mode-scroll-area':viewMode}"
        >
          <b-row>
            <b-col>
              <h5>{{ $t('diagnosis.modals.elementsTitle') }}</h5>
              <p
                v-if="!viewMode"
                class="description-text"
              >
                {{ $t('diagnosis.modals.elementsSubtitle') }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div
                v-if="!viewMode"
                class="tree-scroll-area"
              >
                <liquor-tree
                  ref="tree"
                  :data="items"
                  :options="treeOptions"
                >
                  <div
                    slot-scope="{ node }"
                    :class="{'check-selected':node.states.checked}"
                  >
                    <!-- TODO: Pendiente de mejorar esto en Front, he utilizado un id por las opciones de de liquor tree-->
                    <i
                      v-if="node.data.type === 'sample'"
                      class="fal fa-prescription-bottle mx-2"
                      aria-hidden="true"
                    />
                    <i
                      v-if="node.data.type === 'portion'"
                      class="icon-block mx-2"
                      aria-hidden="true"
                    />
                    <i
                      v-if="node.data.type === 'subportion'"
                      class="icon-porta mx-2"
                      aria-hidden="true"
                    />
                    <span>{{ node.data.text }}</span>
                  </div>
                </liquor-tree>
              </div>
              <div v-if="viewMode">
                <div
                  v-for="(sample, index) in interestItems"
                  :key="index"
                  class="d-flex flex-column mb-1"
                >
                  <span class="description-text dark">{{ $tc('global.sample', 1) }} {{ sample.text }}</span>
                  <div
                    v-for="(portion, indexPortion) in sample.children"
                    :key="indexPortion"
                  >
                    <span class="description-text dark ml-2">{{ $tc('global.block', 1) }} {{ sample.text }}-{{ portion.text }}</span>
                    <div
                      v-for="(subportion, indexSubportion) in portion.children"
                      :key="indexSubportion"
                    >
                      <span class="description-text dark ml-4">{{ $tc('global.slide', 1) }} {{ sample.text }}-{{ portion.text }}-{{ subportion.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TODO: En caso de que en viewMode no haya elementos de interés, aparecerá el siguiente texto-->
              <!-- <span class="description-text dark" v-if="viewMode">{{ $tc('diagnosis.modals.withoutElements') }}</span>-->
            </b-col>
          </b-row>
          <b-row
            v-if="viewMode"
            class="mt-4"
          >
            <b-col>
              <h5>{{ $t('global.observations') }}</h5>
              <p class="description-text dark">
                Lorem ipsum
              </p>
              <!-- TODO: En caso de que en viewMode no haya observaciones, aparecerá el siguiente texto-->
              <!--<p class="description-text dark" v-if="viewMode">{{ $tc('diagnosis.modals.withoutObservations') }}</p>-->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row
        v-if="!viewMode"
        class="mt-3"
      >
        <b-col cols="12">
          <h5>{{ $t('global.observations') }}</h5>
        </b-col>
        <b-col cols="12">
          <b-form-textarea
            rows="3"
            no-resize
          />
        </b-col>
      </b-row>
    </b-container>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            v-if="caseShared"
            qa="share-case-stop"
            :disabled="noUserSelected"
            size="sm"
            class="btn__outline mr-2"
            @click="hide"
          >
            <i
              class="fal fa-times-circle mr-2"
              aria-hidden="true"
            />
            {{ $t('diagnosis.modals.stopSharing') }}
          </b-button>
          <b-button
            v-if="caseShared"
            qa="share-case-update"
            :disabled="noUserSelected"
            size="sm"
            class="btn--primary"
            @click="hide"
          >
            <i
              class="fal fa-edit mr-2"
              aria-hidden="true"
            />
            {{ $t('global.update') }}
          </b-button>
          <b-button
            v-if="!caseShared"
            qa="share-case"
            :disabled="noUserSelected"
            size="sm"
            class="btn--primary"
            @click="hide"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('diagnosis.modals.share') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import LiquorTree from 'liquor-tree'

export default {
    name: 'ShareCaseModal',
    components: {
        LiquorTree
    },
    data() {
        return {
            noUserSelected: false,
            caseShared: false,
            viewMode: false,
            selected: null,
            options: [
                { name: 'Todos los usuarios', code: 'a' },
                { name: 'JOSÉ LUIS RODRÍGUEZ VÁZQUEZ', code: 'b' },
                { name: 'MARÍA JESÚS JIMÉNEZ BAREA', code: 'c' }
            ],
            users: [
                { user: 'RODRÍGUEZ GONZÁLEZ JOSÉ MANUEL', center: 'anatomical pathology3' },
                { user: 'MUNUERA LOBO SUSANA', center: 'anatomical pathology3' },
                { user: 'BLANCH CABELLO CAROLINA', center: 'anatomical pathology3' },
                { user: 'ESTRADA PORTELA LORENZO', center: 'anatomical pathology3' },
                { user: 'SANTANA BRENES JOSEP', center: 'anatomical pathology3' },
                { user: 'COMAS CUESTO JUAN JOSÉ', center: 'anatomical pathology3' }
            ],
            items: [
                { text: 'A',
                    id: 1,
                    data: { type: 'sample' },
                    children: [
                        { text: '1',
                            id: 1,
                            data: { type: 'portion' },
                            children: [
                                { text: '1', id: 1, data: { type: 'subportion' } }
                            ] },
                        { text: '2',
                            id: 2,
                            data: { type: 'portion' },
                            children: [
                                { text: '1', id: 2, data: { type: 'subportion' } },
                                { text: '2', id: 3, data: { type: 'subportion' } },
                                { text: '3', id: 4, data: { type: 'subportion' } }
                            ] }
                    ] },
                { text: 'B', id: 2, data: { type: 'sample' } },
                { text: 'C', id: 3, data: { type: 'sample' } },
                { text: 'D', id: 4, data: { type: 'sample' } }
            ],
            treeOptions: {
                checkbox: true,
                autoCheckChildren: false
            },
            interestItems: [
                { text: 'A',
                    id: 1,
                    children: [
                        { text: '1',
                            id: 2,
                            children: [
                                { text: '1', id: 3 }
                            ] },
                        { text: '2',
                            id: 2,
                            children: [
                                { text: '1', id: 3 },
                                { text: '2', id: 3 }
                            ] }
                    ] }
            ]
        }
    },
    methods: {
        show() {
            this.$refs.shareCaseModal.show()
        },
        hide() {
            this.$refs.shareCaseModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .share-case-modal .view-mode-header .shared-by {
         font-size: font-size(very-small);
     }
    .share-case-modal .view-mode-header .date {
        font-size: font-size(small);
        opacity: .7;
    }
    .share-case-modal .modal-dialog {
        max-width: 60% !important;
    }
    .share-case-modal .modal-body {
        border-radius: 0.3rem;
    }
    .share-case-modal h5 {
        font-size: font-size(very-normal);
    }
    .share-case-modal .list span{
        color: vt-color(dark-text);
    }
    .share-case-modal .list {
        height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .share-case-modal .tree-scroll-area {
        height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .share-case-modal .view-mode-scroll-area {
        height: 390px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .share-case-modal .view-mode-scroll-area .description-text {
        opacity: .7;
    }
    .share-case-modal .header-row {
        position: sticky;
        top: 0;
        background: #FFF;
        z-index: 1;
    }
    .share-case-modal .element-row {
        border-bottom: 1px solid vt-color(grid-general-border);
        padding: 7px 0;
    }
    .share-case-modal .element-row:hover {
        background: vt-color(light-primary);
    }
    .share-case-modal .bordered-column {
        border-left: 1px solid vt-color(general-border);
    }
    .share-case-modal .description-text {
        font-size: font-size(very-small);
        line-height: 14px !important;
    }
    .share-case-modal .tree-checkbox {
        width: 15px;
        height: 15px;
    }
    .share-case-modal .tree-checkbox.checked, .tree-checkbox.indeterminate {
        background-color: vt-color(primary);
        border-color: vt-color(primary);
    }
    .share-case-modal .tree-checkbox.checked:after {
        width: 3px;
        height: 8px;
        top: 0;
        left: 4px;
        transition: none;
    }
    .share-case-modal .tree-content {
        padding: 0;
        position: relative;
        height: 36px;
    }
    .share-case-modal .tree-children .tree-node .tree-content:after {
        display: none;
    }
    .share-case-modal .tree-node:not(.selected)>.tree-content {
        transition: .2s;
    }
    .share-case-modal .tree-content:hover,
    .share-case-modal .tree-node.selected>.tree-content:hover {
        background: vt-color(light-primary) !important;
    }
    .share-case-modal .tree-node.selected>.tree-content {
        background: transparent !important;
    }
    .share-case-modal .check-selected i,
    .share-case-modal .check-selected span {
        color: vt-color(primary);
    }
    .share-case-modal .empty-state i {
        font-size: 30px;
        margin-bottom: 20px;
    }
    .share-case-modal .empty-state {
        opacity: .6;
    }
    .share-case-modal .empty-state span {
        font-size: font-size(small);
        text-align: center;
        margin-top: 20px;
        max-width: 300px;
    }

    @media (max-width: 1300px) {
        .share-case-modal .modal-dialog {
            max-width: 75% !important;
        }
    }

    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .share-case-modal .modal-dialog {
            max-width: 75% !important;
        }
    }
</style>
